import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function SearchMobile() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
          variant="primary"
          onClick={handleShow}
          style={{
            background: "transparent",
            border: "none",
            color: "#777575"
          }}
        >
        <i className="bi bi-search"></i>
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{ padding: "0 8px", backgroundColor:"#f8f8f8" }}>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor:"#f8f8f8" }}>
         <div style={{ padding: "0 8px", position: "relative" }}> 
            <input type="search" className="form-control" placeholder="Search..." style={{}} />
            <div style={{ top:"6px", right:"19px", position:"absolute"}}> <i className="bi bi-search"></i> </div>
         </div>
        </Modal.Body>
      </Modal>

    </>
  );
}
export default SearchMobile;